import PropTypes from 'prop-types';
import Grid from './Grid';

const CardsGrid = ({ size = 'sm', children, ...props }) => (
  <Grid
    className="cards-grid"
    sizes={(
      size === 'sm'
        ? { xs: [1, 2], sm: [1, 3], md: [1, 4], lg: [1, 6], xl: [1, 7] }
        : { xs: [1, 2], md: [1, 3], lg: [1, 4], xl: [1, 5] }
    )}
    {...props}
  >
    {children}
  </Grid>
);

CardsGrid.propTypes = {
  size: PropTypes.oneOf([
    'sm',
    'md',
  ]),
  children: PropTypes.node,
};

export default CardsGrid;
